import React from 'react';
import { useTranslation } from 'react-i18next';
import { PayStateT } from 'routes/HumanResourcesModule/PayState/helpers/types';
import SalaryMass from './SalaryMass';

type Props = {
    payState: PayStateT;
};

const NonPermanentSalaryMass = ({ payState }: Props) => {
    const { t } = useTranslation();

    return (
        <SalaryMass
            payState={payState}
            title={t('humanResources.nonPermanentSalaryMass')}
            tooltip={t('humanResources.nonPermanentSalaryMassTooltip')}
            isForPermanentAgent={false}
        />
    );
};

export default NonPermanentSalaryMass;
